const notificationsList = [
  {
    id: 1,
    isRead: false,
    userId: 1,
    notificationMsg: 'reacted to your recent post',
    itemTitle: 'My first tournament today!',
    itemLink: '#',
    itemImg: '',
    itemMsg: '',
    timeStamp: '1m',
  },
  {
    id: 2,
    isRead: false,
    userId: 2,
    notificationMsg: 'followed you',
    itemTitle: '',
    itemLink: '',
    itemImg: '',
    itemMsg: '',
    timeStamp: '5m',
  },
  {
    id: 3,
    isRead: false,
    userId: 3,
    notificationMsg: 'has joined your group',
    itemTitle: 'Chess Club',
    itemLink: '#',
    itemImg: '',
    itemMsg: '',
    timeStamp: '1 day',
  },
  {
    id: 4,
    isRead: true,
    userId: 4,
    notificationMsg: 'sent you a private message',
    itemTitle: '',
    itemLink: '#',
    itemImg: '',
    itemMsg:
      "Hello, thanks for setting up the Chess Club. I've been a member for a few weeks now and I'm already having lots of fun and improving my game.",
    timeStamp: '5 days',
  },
  {
    id: 5,
    isRead: true,
    userId: 5,
    notificationMsg: 'commented on your picture',
    itemTitle: '',
    itemLink: '#',
    itemImg: require('../assets/images/pictures/image-chess.webp'),
    itemMsg: '',
    timeStamp: '1 week',
  },
  {
    id: 6,
    isRead: true,
    userId: 6,
    notificationMsg: 'reacted to your recent post',
    itemTitle: '5 end-game strategies to increase your win rate',
    itemLink: '#',
    itemImg: '',
    itemMsg: '',
    timeStamp: '2 weeks',
  },
  {
    id: 7,
    isRead: true,
    userId: 7,
    notificationMsg: 'left the group',
    itemTitle: 'Chess Club',
    itemLink: '#',
    itemImg: '',
    itemMsg: '',
    timeStamp: '2 weeks',
  },
];

export default notificationsList;
